import { gql } from '@apollo/client';

export const ONE_MUTUAL = gql`
  query getMutualById {
    getMutualById {
      mId
      mName
      mNit
      mComCit
      mCommerce
      mAuditor
      mComBoo
      mDate
      mLocation
      mEmail
      mPhone
      mNumCIIU
      mNumRUNEOL
      mNamLR
      mGenLR
      mCiuLR
      mTypIdeLR
      mNumIdeLR
      mNamBan
      mNamAccBan
      mAccNum
      mWeb
      mWalletEmail
      mPhoCal
      mPasswordValidityPeriod
      mState
      mutualBanks {
        mbId
        tbId
        atId
        mbAccNum
        mbState
      }
      mModCre
      mPayroll
      mTiIdPR
      mIdeNumPR
      mNamePR
      mGIdPR
      mCIdPR
      city {
        cName
      }
      mPhonePR
      mutualDocuments {
        mdId
        mdType
        mdName
        mdMimeType
        mdSize
        mdDatCre
      }
    }
  }
`;

export const UPLOAD_MUTUAL_DOCUMENT = gql`
  mutation UploadMutualDocument($input: IUploadMutualDocument!) {
    uploadMutualDocument(input: $input) {
      mdId
      mdType
      mdName
      mdMimeType
      mdSize
      mdDatCre
    }
  }
`;

export const DOWNLOAD_MUTUAL_DOCUMENT = gql`
  mutation DownloadMutualDocument($mdId: ID!) {
    downloadMutualDocument(mdId: $mdId) {
      base64
      fileName
      mimeType
    }
  }
`;
export const DELETE_MUTUAL_BANKS = gql`
  mutation SetOrUpdateMutualBank($input: ISetOrUpdateMutualBank!, $mbId: ID) {
    setOrUpdateMutualBank(input: $input, mbId: $mbId) {
      mbId
      mId
      tbId
      atId
      mbAccNum
      mbState
    }
  }
`;

export const SET_OR_UPDATE_MUTUAL = gql`
  mutation setOrUpdateMutual($mId: ID, $input: ISetOrUpdateMutual!) {
    setOrUpdateMutual(mId: $mId, input: $input) {
      mId
      mState
    }
  }
`;

export const ALL_GENDERS = gql`
  query Genders {
    genders {
      gId
      gName
      gState
    }
  }
`;

export const ALL_TYPE_IDENTITIES = gql`
  query typeIdentities($state: [Int], $order: [[String]]) {
    typeIdentities(state: $state, order: $order) {
      tiId
      tiName
      tiState
      tiPrefix
      tiCode
    }
  }
`;

export const ALL_CITIES = gql`
  query Cities {
    cities {
      cId
      dId
      cName
      cCode
      cState
    }
  }
`;
